<template>
  <div class="permission-row permission-tree">
    <div class="field">
      <span class="label">{{ label }}</span>
      <div
        v-if="showInheritCheckbox"
        class="inherit-check-wrapper"
      >
        <UiCheckbox
          :model-value="inherit"
          :disabled="disabled"
          class="permission-tree__checkbox"
          @update:model-value="handleInheritChange"
        />
      </div>
      <div class="field permission-tree__branch">
        <div class="permission-controls">
          <UiRadioGroup
            v-model="permissionType"
            :disabled="disabled || (showInheritCheckbox && inherit)"
            :options="permissionTypesList"
          >
            <UiSelectElement
              :model-value="selectedFields"
              :placeholder="selectPlaceholder"
              :list="fieldList"
              size="big"
              search-param="name"
              option-label-param="name"
              option-name-param="name"
              filterable
              multiple
              collapse-tag-tooltip
              :max-collapse-tags="1"
              :disabled="isTagsInputDisabled || (showInheritCheckbox && inherit)"
              @update:model-value="handleFieldsUpdate"
            />
          </UiRadioGroup>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'PermissionTreeCommon',

  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: '',
    },
    selectPlaceholder: {
      type: String,
      default: '',
    },
    fieldList: {
      type: Object,
      default: () => ({}),
    },
    permissionTypes: {
      type: Array,
      default: () => ['allow_all', 'allow_selected', 'deny_selected'],
    },
    ids: {
      type: Array,
      default: () => [],
    },
    mode: {
      type: String,
      default: null,
    },
    showInheritCheckbox: {
      type: Boolean,
      default: false,
    },
    inherit: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:inherit', 'update:ids', 'update:mode'],
  data() {
    return {
      internalActive: false,
      internalType: null,
    };
  },

  computed: {
    permissionTypesList() {
      let result = [];

      result = this.permissionTypes.map((item) => ({
        label: this.$t(`permissions.${item}`),
        value: item,
      }));
      return result;
    },

    permissionType: {
      get() {
        if (this.showInheritCheckbox && this.inherit) {
          return null;
        }
        return this.internalType || this.mode;
      },
      set(value) {
        this.internalType = value;
        this.$emit('update:mode', value);

        if (value === 'allow_all') {
          this.$emit('update:ids', []);
        }
      },
    },

    selectedFields() {
      return this.ids || [];
    },

    isTagsInputDisabled() {
      return this.permissionType === 'allow_all' || this.disabled || (this.showInheritCheckbox && this.inherit);
    },
  },

  watch: {
    mode: {
      handler(newMode) {
        if (this.isValidPermissionType(newMode)) {
          this.internalType = newMode;
          this.internalActive = true;
        } else {
          this.internalType = null;
          this.internalActive = false;
        }
      },
      immediate: true,
    },
  },

  methods: {
    isValidPermissionType(type) {
      return type && this.permissionTypes.includes(type);
    },

    handleFieldsUpdate(fields) {
      this.$emit('update:ids', fields);
    },

    handleInheritChange(value) {
      this.$emit('update:inherit', value);
      if (!value && !this.permissionType) {
        const [firstType] = this.permissionTypes;
        this.permissionType = firstType;
      }
    },
  },
};

</script>
<style lang="scss" scoped>
.el-select {
  width: 100%;
}
.permission-tree {
  margin-top: 0;
  &__checkbox {
    margin-right: 16px;
  }
}

.inherit-check-wrapper {
  margin-right: 64px;
}
.permission-controls {
  width: 100%;
}
</style>
